import { useFlags } from 'launchdarkly-react-client-sdk';

import Dashboard from '~/components/common/Dashboard';
import ProviderDashboard from '~/components/maud/dashboard/ProviderDashboard';
import ProviderDashboardV2 from '~/components/maud/dashboard/ProviderDashboardV2';

const MaudMainPage = () => {
  const { providerDashboard, providerDashboardV2 } = useFlags<LDFlags>();

  if (providerDashboardV2) return <ProviderDashboardV2 />;

  return providerDashboard ? <ProviderDashboard /> : <Dashboard title="Maud" />;
};

export default MaudMainPage;
